
/*import {scaleLinear,scaleSequential } from 'd3-scale'
import {selection, select, selectAll, event} from 'd3-selection'
import {transition} from 'd3-transition'
import {line} from 'd3-shape'
import {color} from 'd3-color'
import {extent} from 'd3-array'
import {drag} from 'd3-drag'
import {interpolateGreens,interpolateWarm} from 'd3-scale-chromatic'
import {interpolate,interpolateRgb} from 'd3-interpolate'*/
import {sankey, sankeyLinkHorizontal} from 'd3-sankey'
import * as d3 from 'd3'
import {selection, select, selectAll, event} from 'd3-selection'

export default {
  ...d3,
  sankey,
  sankeyLinkHorizontal,
  /*
  selection,
  select,
  selectAll,
  transition,
  scaleLinear,
  scaleSequential,
  interpolateGreens,
  interpolateWarm,
  color,
  interpolate,
  interpolateRgb,
  extent,
  line,
  drag,
  csv,*/
  get event() { return event; },
}